import { AbsoluteFill, useCurrentFrame } from "remotion";
import { COLORS, FONTS, LOGO, CTA_ROUND, BADGE, GLOBS } from "./theme";
import { Background } from "./Background";

export const InstagramPost: React.FC<{
  headline: string;
  body: string;
  cta: string;
}> = ({ headline, body, cta }) => {
  const frame = useCurrentFrame();
  const opacity = Math.min(frame / 15, 1);

  return (
    <AbsoluteFill
      style={{
        background: COLORS.lightWarm,
        fontFamily: FONTS.sans,
        opacity,
      }}
    >
      <Background theme="light" />

      <div
        style={{
          position: "absolute",
          right: -200,
          top: -200,
          width: 700,
          height: 700,
          borderRadius: "50%",
          background: GLOBS.goldLarge,
          filter: "blur(60px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: -100,
          bottom: -100,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: GLOBS.softGlow,
          filter: "blur(40px)",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 60,
          right: 80,
          width: 200,
          height: 200,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.15)",
          opacity: 0.6,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 80,
          right: 100,
          width: 160,
          height: 160,
          borderRadius: "50%",
          border: "0.5px solid rgba(197,160,89,0.1)",
          opacity: 0.4,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 60,
          transform: "translateY(-50%)",
          maxWidth: "62%",
          zIndex: 2,
        }}
      >
        <div
          style={{
            background: "rgba(255,255,255,0.3)",
            backdropFilter: "blur(4px)",
            display: "inline-block",
            padding: "4px 14px",
            border: `1px solid ${COLORS.gold}`,
            color: COLORS.gold,
            fontSize: 10,
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            fontWeight: 900,
            borderRadius: 9999,
            marginBottom: 28,
          }}
        >
          ANÁLISE CORPORAL
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 28,
          }}
        >
          <div style={LOGO}>E</div>
          <span
            style={{
              fontSize: 13,
              color: COLORS.stoneMuted,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              fontWeight: 500,
            }}
          >
            Edson Santoro — Analista Corporal
          </span>
        </div>

        <h1
          style={{
            fontFamily: FONTS.serif,
            fontSize: 72,
            fontWeight: 400,
            color: COLORS.textDark,
            lineHeight: 1.05,
            margin: 0,
            marginBottom: 24,
            letterSpacing: "-0.03em",
            textShadow: "0 2px 8px rgba(0,0,0,0.04)",
          }}
        >
          {headline}
        </h1>

        <p
          style={{
            fontSize: 22,
            color: COLORS.stoneLight,
            lineHeight: 1.6,
            margin: 0,
            marginBottom: 40,
            maxWidth: 500,
            fontWeight: 300,
          }}
        >
          {body}
        </p>

        <div style={CTA_ROUND}>{cta}</div>
      </div>

      <div
        style={{
          position: "absolute",
          right: 60,
          bottom: 60,
          fontSize: 11,
          color: COLORS.stoneSubtle,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          zIndex: 2,
        }}
      >
        @santoro.analista
      </div>
    </AbsoluteFill>
  );
};
